import React from "react";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import { Link } from "react-router-dom";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableSortLabel,
  TablePagination,
  Icon,
} from "@material-ui/core";
import {
  PER_PAGE_OPTIONS,
  DEFAULT_PER_PAGE_RECORDS,
} from "__helpers/constants";
import {
  Button,
  Slide,
} from "@material-ui/core";

import DateFnsUtils from "@date-io/date-fns";

import {
 
  subsDaysToDate,

} from "__helpers/util";
import Scrollbars from "react-custom-scrollbars";
import { dpBaseRoutes } from "base-routes";
import serchIcons from '../../../assets/img/serch.svg';
import { basePath } from "base-routes";
import AddNewSurvey from "./AddNewSurvey";
import SwitchToggle from "components/SwitchToggle/SwitchToggle";
import EditSurvey from "./EditSurvey";
import { apiPath } from "api";
import { userService } from "_services/user.service";
import { generalAuthTokenHeader } from "__helpers/auth-header";
import editIcons from '../../../assets/img/edit.svg';
import taskTemplteCss from "../../../assets/css/taskTemplte.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});
const mapStateToProps = (state) => {
  return {
    userInfoRedux: state.userInfo,
    categoryListRedux: state.categoryList,
    insuranceListRedux: state.insuranceList,
    patientStatusListRedux: state.patientStatusList,
    hospitalListRedux: state.hospitalList,
    timestampRedux: state.timestamp,
    reduxLoadFlag: state.reduxLoadFlag,
  };
};
const headCells = [
  // {
  //   id: "formId",
  //   numeric: false,
  //   disablePadding: false,
  //   sorting: true,
  //   label: "Survey Id",
  // },
  {
    id: "title",
    numeric: false,
    disablePadding: false,
    sorting: true,
    label: "Survey Title",
  },

  {
    id: "description",
    numeric: false,
    disablePadding: false,
    sorting: false,
    label: "Survey Description",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: false,
    sorting: false,
    label: "Action",
  }
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
class surveyTemplate extends React.Component {
  constructor(props) {
    super(props);
    let spinner = document.getElementById("loadingSpinner");
    this.dateUtility = new DateFnsUtils();
    let initialDays = 30;
    let endDate = new Date();
    let startDate = subsDaysToDate(endDate, initialDays);
    let userinfo = JSON.parse(localStorage.getItem("_user_info"));
    this.addressInputRef = React.createRef();
    this.state = {
      action: "",
      loading: false,
      templateName: "",
      taskName: "",
      taskPriority: "2",
      taskDescription: "",
      patientId: "",
      dischargePlannerId: userinfo.dischargePlanner.id,
      facilityId: userinfo.dischargePlanner.facility.facilityId,
      templateStatus: true,
      confirmModalMessage: "",

      dataId: "",
      tempaltes: [],
      surveys: [],
      showModal: false,
  selectedSurveyId: null,
      scrollInterval: null, // Interval ID for scrolling
      scrollSpeed: 10, // Speed of scrolling in pixels per interval
      sortBy: "taskName",
      sortAsc: true,
      perPage: 10,
      total: 0,
      currentPage: 0,
      orderBy: "id",
      spinner: spinner,
      isDelete: false,
      searchKeyword: "",
      apiPartner: "",
      formErrors: {
        taskName: "",
        templateName: "",
        taskDescription: "",
        taskPriority: "",
        tasks: [],
        tempaltes: [],
      },
      taskNameValid: false,
      templateNameValid: false,
      taskDescriptionValid: true,
      taskPriorityValid: true,
      tempaltes: [],
      taskUpdate: false,
      showHelpContent: true,
      
    };
    this.search = this.search.bind(this);

  }

  async fetchInputTypes() {
    this.state.spinner.removeAttribute("hidden", "true");
  
    let showNotification = {};
    const apiUrl = apiPath.GetAllSurveyForm+this.state.dischargePlannerId; // <-- your API endpoint
  
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });
  
      if (response.status === 400) {
        showNotification = { title: "Input Types", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = { title: "Input Types", message: "Error fetching data", type: "danger" };
      }
  
      const data = await response.data;
      console.log("Input Types Fetched: ", data);
      console.log("Input Types Fetched: ", response.data);
  
      this.setState({ surveys: data }); // <-- update surveys from API
  
      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error fetching input types", error);
      showNotification = { title: "Input Types", message: "Server Error", type: "danger" };
      userService.showNotification(showNotification);
    }
  
    this.state.spinner.setAttribute("hidden", "true");
  }
  
   async fetchSurveys(searchKeyword) {
      this.state.spinner.removeAttribute("hidden", "true");
      let showNotification = {};
      let apiUrl = "";
      if (searchKeyword) {
        apiUrl =
          apiPath.GetAllSurveyForm +
          "?dpId=" +
          this.state.dischargePlannerId +
          "&page=" +
          this.state.currentPage +
          "&size=" +
          this.state.perPage +
          "&sort=" +
          this.state.orderBy +
          "," +
          (this.state.direction ? "asc" : "desc") +
          "&search=" +
          searchKeyword;
      } else {
        apiUrl =
          apiPath.GetAllSurveyForm +
          "?dpId=" +
          this.state.dischargePlannerId +
          "&page=" +
          this.state.currentPage +
          "&size=" +
          this.state.perPage +
          "&sort=" +
          this.state.orderBy +
          "," +
          (this.state.direction ? "asc" : "desc") +
          "";
      }
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      })
        .then((response) => {
          if (response.status === 400) {
            showNotification = {
              title: "Template",
              message: "Bad response from server",
              type: "danger",
            };
          } else if (response.ok) {
            // this.setState({
            //   total: response.headers.get("X-Total-Count"),
            // });
          } else if (response.status === 401) {
            userService.logout();
            window.location.reload(true);
          } else {
            showNotification = {
              title: "Template",
              message: "Bad response from server",
              type: "danger",
            };
          }
          return response.json();
        })
        .then((data) => {
          console.log("Fetch Survey Data", data);
          this.setState({
            surveys: data.content,
            total:data.totalElements
          });
        })
        .catch((error) => {
          showNotification = {
            title: "Task Template",
            message: "Bad response from server",
            type: "danger",
          };
          return response;
        });
  
      userService.showNotification(showNotification);
      this.state.spinner.setAttribute("hidden", "true");
    }
  componentDidMount() {
    this.fetchSurveys();
  }
  
  modalOpen = (id) => {
    this.setState({
      showModal: true,
      selectedSurveyId: id
    });
  };
  
  handleClose = () => {
    this.setState({
      showModal: false,
      selectedSurveyId: null
    });
  };
  
  tableSortHandler = (property) => (event) => {
    this.setState(
      {
        orderBy: property,
        direction: !this.state.direction,
      },
      () => this.fetchSurveys(this.state.searchKeyword)
    );
  };

  search(event) {
    let searchKeyword = event.target.value.trim();
    if (searchKeyword.length > 0) {
      this.setState({ currentPage: 0 }, () =>
        this.fetchSurveys(searchKeyword)
      );
    } else {
      this.fetchSurveys();
    }
    this.setState({ searchKeyword: searchKeyword });
    return true;
  }

  handleChangePage = (event, newPage) => {
    this.setState(
      {
        currentPage: newPage,
      },
      () => this.fetchSurveys()
    );
  };
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        perPage: parseInt(event.target.value),
        currentPage: 0,
      },
      () => this.fetchSurveys()
    );
  };

  render() {
    const { tasks, dataId, sortBy, sortAsc } = this.state;
    return (
      <div id="facility-index">
       
        <GridContainer>
          <Scrollbars
            //style={{ height: "600px" }}
            autoHide={false}
            universal={true}
            autoHeight={true}
            autoHeightMin={0}
            autoHeightMax={600}
          >
            <Card className={"advert-cover"}>
              <GridItem xs={12} sm={12} md={12}>
                <CardHeader
                  color="success"
                  className={"cusCardheader cusCardTitle"}
                >
                  <h4>Survey Template</h4>
                </CardHeader>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className="search-btn-cover">
                  <input
                    type="text"
                    title="Search by Template name"
                    placeholder="Search by Survey name"
                    className="search-btn"
                    onChange={this.search}
                  />
                  {/* <i className="material-icons">search</i> */}
                  <img src={serchIcons} alt="" srcset=""className="material-icons" />
                </div>
                  <AddNewSurvey onClose={this.handleClose} />

              </GridItem>
              <div className={"custom-container"}>
                <div className="tableResponsive">
                  <Table>
                    <TableHead>
                      <TableRow>
                        {headCells.map((headCell, index) => (
                          <TableCell
                            key={headCell.id}
                            align={
                              index === headCells.length - 1
                                ? "center" // last column alignment
                                : headCell.numeric
                                ? "right"
                                : "left"
                            }
                            padding={
                              headCell.disablePadding ? "none" : "default"
                            }
                          >
                            {headCell.sorting ? (
                              <TableSortLabel
                                active={this.state.orderBy == headCell.id}
                                direction={
                                  this.state.direction ? "asc" : "desc"
                                }
                                onClick={this.tableSortHandler(headCell.id)}
                              >
                                {headCell.label}
                              </TableSortLabel>
                            ) : (
                              headCell.label
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    {this.state.surveys.length ? (
                        this.state.surveys.map((survey) => (
                          <TableRow key={survey.formId}>
                            {/* <TableCell>{survey.formId}</TableCell> */}
                            <TableCell>{survey.title}</TableCell>
                            <TableCell>{survey.description}</TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                                                {/* <span */}
                        {/* // className="edit-action" */}
                        {/* // onClick={() => this.setState({ showModal: true, selectedSurveyId: survey.formId })} */}
                      {/* > */}
                        {/* <Icon className="fa fa-pencil-square-o" aria-hidden="true" /> */}

                      {/* </span> */}
                      <img src={editIcons} alt="" srcset="" onClick={() => this.setState({ showModal: true, selectedSurveyId: survey.formId })} style={{cursor:"pointer"}}/>

                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan="3">
                        <div className="not-found-text">Surveys not found</div>
                      </TableCell>
                    </TableRow>
                  )}


                  </Table>
                </div>
                <TablePagination
                  rowsPerPageOptions={PER_PAGE_OPTIONS}
                  component="div"
                  count={this.state.total}
                  rowsPerPage={this.state.perPage}
                  page={this.state.currentPage}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </div>
            </Card>
          </Scrollbars>
        </GridContainer>
        {this.state.showModal && (
  <EditSurvey
    open={true}
    surveyId={this.state.selectedSurveyId}
    onClose={this.closeModal}
    surveyList={this.state.surveyList}
    history={this.props.history} // important if used inside
  />
)}

      </div>
    );
  }
}
export default surveyTemplate;
